export enum RolloverOptions {
    DoNotReinvest = 0,
    Principal = 1,
    PrincipalAndInterest = 2,
}
